<template>
  <div
    :class="[{'bg-transparent': transparent}, zIndexStyle]"
    class="app-backdrop"
    @click="$emit('click')"
  >
    <slot />
  </div>
</template>

<script>
export default {
  // Name
  name: 'AppBackdrop',

  // Props
  props: {
    transparent: {
      type: Boolean
    },

    zIndex: {
      type: String,
      default: 'z-20'
    }
  },

  computed: {
    zIndexStyle () {
      return this.zIndex
    }
  }
}
</script>

<style scoped lang="scss">
.app-backdrop {
  @apply fixed left-0 h-screen top-0 w-full;

  &:not(.bg-transparent) {
    @apply backdrop-blur-[10px] bg-black bg-opacity-70;
  }
}
</style>
